// src/lib/api/utilities/vendors.js
import { supabase } from '../../supabase'
import { getValidatedCompanyId } from '../shared/helpers'
import { withErrorHandling, createSuccessResponse } from '../shared/errors'
import { logger } from '../../logger'

/**
 * Get vendors
 * Migrated from supabaseApi.js lines 550-571
 */
const _getVendors = async (companyId = null) => {
  logger.utilities('getVendors called with companyId:', companyId)
  
  const resolvedCompanyId = companyId || await getValidatedCompanyId()
  if (!resolvedCompanyId) {
    console.warn('[utilities] No company ID found')
    return createSuccessResponse([])
  }

  const { data, error } = await supabase
    .from('vendors')
    .select('*')
    .eq('company_id', resolvedCompanyId)
    .order('name', { ascending: true })
    
  if (error) {
    console.error('[utilities] Error fetching vendors:', error)
    throw error
  }

  logger.utilities('getVendors success, found', data?.length || 0, 'vendors')
  return createSuccessResponse(data || [])
}

/**
 * List vendors (simplified version)
 * Migrated from supabaseApi.js lines 1060-1076
 */
const _listVendors = async () => {
  logger.utilities('listVendors called')
  
  const companyId = await getValidatedCompanyId()
  if (!companyId) {
    console.warn('[utilities] No company ID found')
    return createSuccessResponse([])
  }

  const { data, error } = await supabase
    .from('vendors')
    .select('id, name, default_category_id')
    .eq('company_id', companyId)
    .order('name', { ascending: true })
    
  if (error) {
    console.error('[utilities] Error listing vendors:', error)
    throw error
  }

  logger.utilities('listVendors success, found', data?.length || 0, 'vendors')
  return createSuccessResponse(data || [])
}

// Export functions with error handling
export const getVendors = withErrorHandling(_getVendors, 'get vendors', 'vendors')
export const listVendors = withErrorHandling(_listVendors, 'list vendors', 'vendors')